<div class="position-absolute" *ngIf="!exitPermission('home.view')">
    <span class="position-absolute__content">
      No tiene permisos para ver esta información
    </span>
</div>

<div class="dashboard" *ngIf="exitPermission('home.view')">
  <div class="filters">
    <app-select-search-renewed class="select-field" matTooltip="ADMINISTRADORAS" matTooltipShowDelay="500" matTooltipHideDelay="300"
                               [_dataSource]="companies" [textInput]="'ADMINISTRADORAS'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="controlCompanies"
                               [inputType]="'text'" (onSelectionChange)="onChangeSelectedCompany($event)">
    </app-select-search-renewed>
    <app-select-search-renewed class="select-field" matTooltip="PROYECTO" matTooltipShowDelay="500" matTooltipHideDelay="300"
                               [_dataSource]="proyects" [textInput]="'PROYECTO'" [dataShow]="'Name'" [dataValue]="'Id'" [siteCtrl]="controlProyects"
                               [inputType]="'text'" (onSelectionChange)="onChangeSelectedPro($event)">
    </app-select-search-renewed>
    <app-select-search-renewed class="select-field" matTooltip="EMPRESA CONTRATISTA" matTooltipShowDelay="500" matTooltipHideDelay="300"
                               [_dataSource]="employers" [textInput]="'EMPRESA CONTRATISTA'" [dataShow]="'Name'" [otherFilter]="'DocumentNumber'" [dataValue]="'Id'" [siteCtrl]="controlEmployers"
                               [inputType]="'text'" (onSelectionChange)="onChangeSelectedEmp($event)">
    </app-select-search-renewed>
    <app-select-search-renewed class="select-field" matTooltip="CONTRATO" matTooltipShowDelay="500" matTooltipHideDelay="300"
                               [_dataSource]="contracts" [textInput]="'CONTRATO'" [dataShow]="'ContractReview'" [otherFilter]="'ContractNumber'" [dataValue]="'Id'" [siteCtrl]="controlContracts"
                               [inputType]="'text'" (onSelectionChange)="onChangeSelectedContract($event)">
    </app-select-search-renewed>

    <app-select-search-renewed class="select-field" matTooltip="CATEGORIA" matTooltipShowDelay="500" matTooltipHideDelay="300"
                               [_dataSource]="jsonDashboardFilters[0]?.categoria" [textInput]="'CATEGORIA'" [dataShow]="'Name'"  [dataValue]="'Value'" [siteCtrl]="this.formFilters.get('categorias')"
                               [inputType]="'text'" [disabled]="controlContracts.value !== '-1'" (onSelectionChange)="changeSubFilter($event)">
    </app-select-search-renewed>

    <app-select-search-renewed class="select-field" matTooltip="SEXO" matTooltipShowDelay="500" matTooltipHideDelay="300"
                               [_dataSource]="jsonDashboardFilters[0]?.sexo" [textInput]="'SEXO'" [dataShow]="'Name'" [dataValue]="'Value'" [siteCtrl]="this.formFilters.get('sexo')"
                               [inputType]="'text'" (onSelectionChange)="changeSubSex($event)">
    </app-select-search-renewed>
  </div>

  <div class="list">
    <form class="filters" [formGroup]="formFilters">
      <div class="card-nivel-1 calendar-card">
        <div class="calendar-icon-wrapper" (click)="picker.open()">
          <mat-icon class="calendar-icon" style="color: rgb(254, 140, 0);">access_time</mat-icon>
        </div>
        <div class="calendar-date-row">
              <span class="calendar-date">
                 {{ formatDateForView() }}
              </span>
        </div>
        <input
          [matDatepicker]="picker"
          [max]="today"
          style="display: none;"
          formControlName="selectedDate"
          (dateChange)="onDateChange($event.value)" />
        <mat-datepicker-toggle matSuffix [for]="picker" style="display: none;"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
      <div class="card-nivel-1" style="margin-left: 20px;">
        <div class="card-img-1">
          <mat-icon style="color: white;" md-svg-src="https://s3.amazonaws.com/analityco-acceso/assets/icons/common/req.svg" role="img" aria-hidden="true">
            person
          </mat-icon>
        </div>
        <div class="card-content-nivel-1">
          <div class="field">{{'Activo / vinculados' || ''}}</div>
          <div class="indicators">
            <div class="valores"  >
              {{total?.Active || '0'}}/{{total?.Total || '0'}}
            </div>
            <div class="porcentaje" style="margin-right: 19px;">
              {{getPercentage(total?.Active, total?.Total) || '0'}}
            </div>
          </div>
        </div>
      </div>
      <div class="card-nivel-1" style="margin-left: 20px;">
        <div class="card-img-1">
          <mat-icon style="color: white;" md-svg-src="https://s3.amazonaws.com/analityco-acceso/assets/icons/common/new.svg" role="img" aria-hidden="true"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 210 210" style="enable-background:new 0 0 210 210;" xml:space="preserve" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                    <path d="M126,42c0,23.2-18.8,42-42,42S42,65.2,42,42S60.8,0,84,0S126,18.8,126,42z M0,168v-21
                        c0,0,19.9-42,84-42c16.9,0,30.8,2.9,42,7.3V126H84v42H0z M210,147h-42v-42h-21v42h-42v21h42v42h21v-42h42V147z"></path>
                </svg></mat-icon>
        </div>
        <div class="card-content-nivel-1">
          <div class="field">{{'Nuevos' || ''}}</div>
          <div class="indicators">
            <div class="valores"  >
              {{total?.NewPersonal || '0'}}/{{total?.Total || '0'}}
            </div>
            <div class="porcentaje" style="margin-right: 19px;">
              {{getPercentage(total?.NewPersonal, total?.Total) || '0'}}
            </div>
          </div>
        </div>
      </div>
      <div class="card-nivel-1" style="margin-left: 20px;">
        <div class="card-img-1">
          <mat-icon style="color: white;" md-svg-src="https://s3.amazonaws.com/analityco-acceso/assets/icons/common/inactive.svg" role="img" aria-hidden="true"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 210 210" style="enable-background:new 0 0 210 210;" xml:space="preserve" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
                    <path d="M126,42c0,23.2-18.8,42-42,42S42,65.2,42,42S60.8,0,84,0S126,18.8,126,42z M0,168v-21
                        c0,0,19.9-42,84-42c12.8,0,23.8,1.7,33.2,4.3l-11.2,12l-14.2,14.2l30.4,30.4L120,168H0z M210,135l-14.2-14.2l-30.4,30.4L135,120.8
                        L120.8,135l30.4,30.4l-30.4,30.4L135,210l30.4-30.4l30.4,30.4l14.2-14.2l-30.4-30.4L210,135z"></path>
                </svg></mat-icon>
        </div>
        <div class="card-content-nivel-1">
          <div class="field">{{'Incumplimiento' || ''}}</div>
          <div class="indicators">
            <div class="valores"  >
              {{total?.NoCumple || '0'}}/{{total?.Presence || '0'}}
            </div>
            <div class="porcentaje" style="margin-right: 19px;">
              {{getPercentage(total?.NoCumple, total?.Presence) || '0'}}
            </div>
          </div>
        </div>
      </div>
      <div class="card-nivel-1" style="margin-left: 20px;">
        <div class="card-img-1">
          <div class="circle-icon">
            <img src="https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/icons/dashboard/present_person.png" alt="icono" />
          </div>
        </div>
        <div class="card-content-nivel-1">
          <div class="field">{{'Ingresos Hoy' || ''}}</div>
          <div class="indicators">
            <div class="valores"  >
              {{total?.Presence || '0'}}/{{total?.Active || '0'}}
            </div>
            <div class="porcentaje" style="margin-right: 19px;" >
              {{getPercentage(total?.Presence, total?.Active) || '0'}}
            </div>
          </div>
        </div>
      </div>
      <div class="card-nivel-1" style="margin-left: 20px;">
        <div class="card-img-1">
          <div class="circle-icon">
            <img src="https://analityco-acceso.s3.us-east-1.amazonaws.com/assets/icons/dashboard/person_in_project.png" alt="icono" />
          </div>

        </div>
        <div class="card-content-nivel-1">
          <div class="field">{{'En el proyecto' || ''}}</div>
          <div class="indicators">
            <div class="valores"  >
              {{ total?.CheckedInOnly || '0' }}/{{ total?.Presence || '0' }}
            </div>
            <div class="porcentaje" style="margin-right: 19px;">
              {{ getPercentage(total?.CheckedInOnly, total?.Presence) || '0' }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Summary Cards -->
  <!-- Employer Chart Section -->
  <div class="charts-dashboard-section"  *ngIf="controlProyects.value && controlProyects.value !== '-1'"  style="margin-top: 30px;">
    <div class="charts-header" style="background: rgb(226, 226, 226); color: white; padding: 12px;">
      <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
        <div>
          <h2 style="margin: 0; font-size: 24px; font-weight: 600; display: flex; align-items: center; gap: 8px;">
            <mat-icon aria-hidden="true">business</mat-icon>
            ASISTENCIA POR EMPRESA
          </h2>
          <p style="margin: 5px 0 0 0; color: black; font-weight: bold; font-size: 14px;">
            Gráfico de entradas y salidas por empresa.
          </p>
        </div>
        <div style="display: flex; align-items: center; gap: 15px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <label style="font-weight: 500; color: black; white-space: nowrap;">📊 Categoría:</label>
            <select
              [value]="selectedChartCategory"
              (change)="onChartCategoryChange($event.target.value)"
              style="padding: 8px 12px; border: none; border-radius: 6px; font-size: 14px; background: rgba(255,255,255,0.95); color: #333; min-width: 140px;">
              <option *ngFor="let category of chartCategories" [value]="category.key">
                {{category.label}}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart Controls -->
    <div class="chart-controls" style="background: #f8f9fa; padding: 20px; border: 1px solid #e9ecef; border-top: none; display: flex; flex-wrap: wrap; gap: 15px; align-items: center; justify-content: space-between;">
      <!-- Display Options -->
      <div class="display-options" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
        <strong style="color: #495057; margin-right: 10px;">👁️ Mostrar por:</strong>

        <!-- Show All Toggle -->
        <button
          (click)="toggleShowAllCompanies()"
          [style.background-color]="showAllCompanies && !showAllList ? '#28a745' : 'white'"
          [style.color]="showAllCompanies && !showAllList ? 'white' : '#6c757d'"
          [style.border-color]="showAllCompanies && !showAllList ? '#28a745' : '#6c757d'"
          style="padding:6px 12px; border:1px solid; border-radius:4px; font-size:12px; cursor:pointer; transition:all .2s;">
          {{ showAllCompanies ? 'All' : 'Limited' }}
        </button>

        <!-- Botón Solo con asistentes -->
        <button
          (click)="toggleOnlyWithPresence()"
          [style.background-color]="showOnlyWithAttendance && !showAllList ? '#28a745' : 'white'"
          [style.color]="showOnlyWithAttendance && !showAllList ? 'white' : '#6c757d'"
          [style.border-color]="showOnlyWithAttendance && !showAllList ? '#28a745' : '#6c757d'"
          style="padding:6px 12px; border:1px solid; border-radius:4px; font-size:12px; cursor:pointer; transition:all .2s;">
          Solo con asistentes
        </button>

        <!-- Botón Mostrar todas las empresas -->
        <button
          (click)="toggleShowAllList()"
          [style.background-color]="showAllList ? '#28a745' : 'white'"
          [style.color]="showAllList ? 'white' : '#6c757d'"
          [style.border-color]="showAllList ? '#28a745' : '#6c757d'"
          style="padding:6px 12px; border:1px solid; border-radius:4px; font-size:12px; cursor:pointer; transition:all .2s;">
          Mostrar todas las empresas
        </button>
      </div>

      <!-- Data Status and Export -->
      <div class="status-group" style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center;">
        <div style="display: flex; align-items: center; gap: 8px; color: #6c757d; font-size: 14px;">
          <span style="width: 8px; height: 8px; border-radius: 50%;"
                [style.background]="getDataStatusColor()"></span>
          <span>Records: <strong>{{ getChartDataLength() }}</strong></span>
        </div>
        <div style="display: flex; align-items: center; gap: 8px; color: #6c757d; font-size: 14px;">
          <span>Empresas: <strong>{{ getTotalCompaniesCount() }}</strong></span>
        </div>
        <!-- <button
         (click)="exportChartData()"
         [disabled]="hasNoChartData()"
         style="padding: 8px 14px; border: 1px solid #6c757d; border-radius: 6px; background: white; color: #6c757d; font-size: 12px; cursor: pointer; transition: all 0.2s;"
         title="Export chart data as JSON">
         💾 Exportar datos.
       </button>  -->
      </div>
    </div>

    <!-- Chart Container -->
    <div class="charts-container" style="background: white; border: 1px solid #e9ecef; border-top: none; border-radius: 0 0 8px 8px; padding: 20px;">
      <!-- No Data Message -->
      <div *ngIf="hasNoChartData()" class="no-data-message" style="text-align: center; padding: 60px 20px; color: #6c757d;">
        <div style="font-size: 48px; margin-bottom: 20px;">🏢</div>
        <h3 style="margin: 0 0 10px 0; color: #495057;">No hay datos disponibles,</h3>
        <p style="margin: 0; font-size: 14px;">Seleccione un proyecto y una fecha para cargar los datos del gráfico.</p>
      </div>

      <!-- Employer Chart -->
      <div *ngIf="hasChartData()" class="chart-container" style="background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); padding: 20px; transition: transform 0.2s, box-shadow 0.2s;">
        <div [style.height]="getChartHeight()" style="position: relative;">
          <canvas
            id="employerChart"
            style="max-height: 100%; width: 100%; border-radius: 8px;">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>





